module.exports = __webpack_public_path__ + "static/media/efeito_03.631086a2.png";